import { KeyPath } from 'src/types';

const expand = <T>(obj: T, path: KeyPath<T>): number | string | undefined => {
  const properties = path.split('.');
  return properties.reduce((acc: any, cur: any) => acc?.[cur], obj);
};
interface SearchItemProps<T> {
  /**
   * List of items to search through.
   */
  items: T[];
  /**
   * List of {@link KeyPath}(s) in T.
   * The 'words' in the `query` are only searched for in the values at these
   * paths that are `numbers` or `strings`.
   */
  params: KeyPath<T>[];
  /**
   * Query containing space separated 'words' to use in search.
   */
  query: string;
}

export const searchItems = <T>({
  items,
  params,
  query,
}: SearchItemProps<T>) => {
  const result: T[] = [];

  const lowerCaseQuery = query.toLocaleLowerCase();

  items.forEach((item) => {
    for (const param of params) {
      const val = expand(item, param);

      if (
        (typeof val === 'number' && val.toString().includes(lowerCaseQuery)) ||
        (typeof val === 'string' &&
          val.toLocaleLowerCase().includes(lowerCaseQuery))
      ) {
        result.push(item);
        break;
      }
    }
  });

  return result;
};
